import { useModal } from '@/hooks'
import React from 'react'
import style from './styles/contest_work.module.scss'

const ContestWork = (): React.ReactElement => {
  const { modalProps } = useModal()

  const { image, number, author, date } = modalProps

  return (
    <div className={style.work}>
      <img
        src={image}
        width='800px'
        height='900px'
        alt='Фото работы'
        className={style.work__image}
      />
      <div className={style.work_content}>
        <span className={style.work__number}>№{number}</span>
        <span className={style.work__author}>{author}</span>
        <span className={style.work__date}>{date}</span>
      </div>
    </div>
  )
}

export default ContestWork
